import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';

const GuestGuard = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { user } = useAuth();

  if (isAuthenticated && (user.idprofilo==1 || user.idprofilo == 8 || user.idprofilo == 3)) {
    return <Redirect to="/app/reports/dashboard-kpi" />;
  }
  else if (isAuthenticated && user.idprofilo==4) {
    return <Redirect to="/app/tablet/homeTablet" />;
  }
  else if (isAuthenticated && user.idprofilo==5) {
    return <Redirect to="/app/operator/homeOperator" />;
  }
  else if (isAuthenticated && user.idprofilo==7) {
    return <Redirect to="/forbidden" />;
  }


  return (
    <>
      {children}
    </>
  );
};

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default GuestGuard;
